export const GA_EVENT_NAMES = {
  PAGE_VIEW: 'page-view',
  SUB_PAGE_VIEW: 'sub-page-view',
  ROLE_CHANGED: 'role-changed',
  ACTION_MENU: 'action-menu',
  CLICK: 'click',
  FILTER: 'filter',
  FILE_DOWNLOAD: 'file-download',
  SEARCH: 'search',
  ERROR: 'error',
} as const;

export const GA_SUBPAGE_TYPE = {
  MODAL: 'modal',
  DRAWER: 'drawer',
  TOOLTIP: 'tooltip',
} as const;

export const GA_INTERNAL_DOMAINS = [
  'consilio.com',
  'consiliotest.com',
  'consilioservices.com',
];

export const GA_PREFIX = 'avr';

export const GA_BLACKLIST_URLS = ['/callback'];

export const GA_NON_USER_ROUTES = ['/login', '/callback', '/logout'];

export const GA_DATA_MODE_AUTO = 'AUTO' as const;

export const GA_CLICK_TYPES = {
  BUTTON: 'button',
  ICON: 'icon',
  LINK: 'link',
  MENU_ITEM: 'menu item',
  TOOLTIP: 'tooltip',
  DROPDOWN: 'dropdown',
  CHECKBOX: 'checkbox',
} as const;

export const GA_REGIONS = {
  LEFT_RAIL: 'left rail',
  FOOTER: 'footer',
  MODAL: 'modal',
  BODY: 'body',
  MENU: 'menu',
  SAVED_SEARCH: 'saved search',
  SAVED_SEARCH_MENU: 'saved search menu',
  SAVED_SEARCH_GROUP_MENU: 'saved search group menu',
  SAVED_SEARCH_COLUMNS: 'saved search columns',
  SAVED_SEARCH_FILTERS: 'saved search filters',
  SAVED_SEARCH_RESULTS: 'saved search results',
} as const;

export const GA_STATIC_URL_MAPPING: Record<string, string> = {
  '/callback': '/login',
};

export const GA_ERROR_CODES = {
  NOT_FOUND_404: '404',
  NOT_AUTHORIZED_401: '401',
  BAD_REQUEST: '400',
  INTERNAL_SERVER_ERR_500: '500',
} as const;

export const GA_ERROR_TYPES = {
  PAGE_NOT_FOUND: 'page not found',
  AUTHENTICATION_ERROR: 'authentication error',
} as const;
